import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { BackendHttpParameterService } from "../../backend-http-parameter.service";

@Injectable({
  providedIn: "root",
})
export class NationalityHttpService {
  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _backendHttpParameterService: BackendHttpParameterService,
  ) {}

  get() {
    const url = environment.backendBaseUrl + "/staticdata/nationalities";

    const httpHeaders =
      this._backendHttpParameterService.createDefaultBackendHttpHeaders();

    const response = this._httpClient.get<NationalityResponseDto>(url, {
      headers: httpHeaders,
    });

    return response;
  }
}

export interface NationalityResponseDto {
  nationalities: NationalityDto[];
}

export interface NationalityDto {
  code: string;
  country: string;
}

export const SWISS_NATIONALITY_CODE = "CH";
export const LIECHTENSTEIN_NATIONALITY_CODE = "LI";
